import type { AppConfig } from './AppConfig.js';
/** @deprecated Use `AppConfig` instead */
export type UserConfig = AppConfig;
